import Vue from 'vue'
import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'

export default Vue.extend({
  mounted () {
    if (this.$can(AbilityAction.Do, AbilitySubject.Ops)) {
      this.$store.direct.dispatch.team.subscribeAllTeams()
    }
  },
  beforeDestroy () {
    if (this.$can(AbilityAction.Do, AbilitySubject.Ops)) {
      this.$store.direct.dispatch.team.unsubscribeAllTeams()
    }
  }
})
